import EntitySubscriptionModal from './EntitySubscriptionModal';

export default EntitySubscriptionModal;
